/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Bookora API
 * API for **bookora.net** — multi-tenant SaaS for Iranian beauty clinics and
 * aesthetic doctors.
 *
 * ## Conventions
 *
 * - **Versioning**: customer-facing routes live under `/api/v1/...`. The health
 *   probes (`/health`, `/ready`) are unprefixed and version-neutral.
 * - **Response envelope**: every successful JSON response is
 *   `{ "data": <payload>, "meta"?: <extra> }`.
 * - **Error envelope**: every error response is
 *   `{ "statusCode": number, "code": string, "message": string, "details"?: any, "requestId"?: string }`.
 *   `code` is a stable token from `ErrorCode`; `message` is finished Persian copy.
 * - **Pagination**: list endpoints take 1-indexed `?page=&pageSize=` and return
 *   `{ items, page, pageSize, total, pageCount }` inside `data`.
 * - **Auth**: bearer JWT. Tokens come from `/api/v1/auth/otp/verify` and rotate on
 *   `/api/v1/auth/refresh`. There are no passwords in this product.
 * - **Tenancy**: the access token carries the clinic. Every tenant-scoped query is
 *   filtered by it server-side; a `clinicId` in a path or body must agree with the
 *   token or the request is rejected.
 * - **Currency**: every money field is an integer in **rials**. Panels display
 *   toman (1 toman = 10 rials).
 * - **Quantities**: integer milli-units (`…Milli`, 1 unit = 1000).
 *   **Percentages**: basis points (`…PercentBp`, 1% = 100).
 * - **Timestamps**: UTC ISO-8601. Jalali conversion happens in the UI.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AppointmentListResponse,
  AppointmentResponse,
  AppointmentsCalendarParams,
  AppointmentsCancel200,
  AppointmentsFreeSlotsParams,
  AppointmentsListParams,
  CalendarResponse,
  CancelAppointmentDto,
  ChangeAppointmentStatusDto,
  CreateAppointmentDto,
  FreeSlotResponse,
  RescheduleAppointmentDto,
  SchedulingErrorResponse,
  UpdateAppointmentDto
} from '../model';

import { apiClient } from '../../mutator';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * فهرست صفحه‌بندی‌شدهٔ نوبت‌ها با فیلتر بازه، وضعیت، پزشک، اتاق و بیمار. کاربری که appointment.view_all ندارد فقط نوبت‌های خودش را می‌بیند.
 * @summary فهرست نوبت‌ها
 */
export const appointmentsList = (
    params?: AppointmentsListParams,
 signal?: AbortSignal
) => {


      return apiClient<AppointmentListResponse>(
      {url: `/api/v1/appointments`, method: 'GET',
        params, signal
    },
      );
    }




export const getAppointmentsListQueryKey = (params?: AppointmentsListParams,) => {
    return [
    `/api/v1/appointments`, ...(params ? [params] : [])
    ] as const;
    }


export const getAppointmentsListQueryOptions = <TData = Awaited<ReturnType<typeof appointmentsList>>, TError = unknown>(params?: AppointmentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppointmentsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appointmentsList>>> = ({ signal }) => appointmentsList(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appointmentsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppointmentsListQueryResult = NonNullable<Awaited<ReturnType<typeof appointmentsList>>>
export type AppointmentsListQueryError = unknown


export function useAppointmentsList<TData = Awaited<ReturnType<typeof appointmentsList>>, TError = unknown>(
 params: undefined |  AppointmentsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appointmentsList>>,
          TError,
          Awaited<ReturnType<typeof appointmentsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppointmentsList<TData = Awaited<ReturnType<typeof appointmentsList>>, TError = unknown>(
 params?: AppointmentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appointmentsList>>,
          TError,
          Awaited<ReturnType<typeof appointmentsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppointmentsList<TData = Awaited<ReturnType<typeof appointmentsList>>, TError = unknown>(
 params?: AppointmentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary فهرست نوبت‌ها
 */

export function useAppointmentsList<TData = Awaited<ReturnType<typeof appointmentsList>>, TError = unknown>(
 params?: AppointmentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsList>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppointmentsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * نوبت تازه روی تقویم. تداخل با نوبت‌های دیگرِ همان پزشک یا پر بودن ظرفیت اتاق با خطای ۴۰۹ رد می‌شود؛ این بررسی داخل تراکنش و پشت قفل انجام می‌شود، پس دو ثبت هم‌زمان روی یک زمان هرگز هر دو موفق نمی‌شوند.
 * @summary ثبت نوبت
 */
export const appointmentsCreate = (
    createAppointmentDto: CreateAppointmentDto,
 signal?: AbortSignal
) => {


      return apiClient<AppointmentResponse>(
      {url: `/api/v1/appointments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAppointmentDto, signal
    },
      );
    }




export const getAppointmentsCreateMutationKey = () => ['appointmentsCreate'] as const;

export const getAppointmentsCreateMutationOptions = <TError = SchedulingErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsCreate>>, TError,AppointmentsCreateMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof appointmentsCreate>>, TError,AppointmentsCreateMutationVariables, TContext> => {

const mutationKey = getAppointmentsCreateMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appointmentsCreate>>, AppointmentsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  appointmentsCreate(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppointmentsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof appointmentsCreate>>>
    export type AppointmentsCreateMutationBody = CreateAppointmentDto
    export type AppointmentsCreateMutationError = SchedulingErrorResponse
    export type AppointmentsCreateMutationVariables = {data: CreateAppointmentDto}

    /**
 * @summary ثبت نوبت
 */
export const useAppointmentsCreate = <TError = SchedulingErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsCreate>>, TError,AppointmentsCreateMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appointmentsCreate>>,
        TError,
        AppointmentsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAppointmentsCreateMutationOptions(options), queryClient);
    }
    /**
 * همهٔ چیزی که نمای روز/هفته لازم دارد در یک درخواست: نوبت‌ها، پزشکان، اتاق‌ها، مرخصی‌ها و شیفت‌های هفتگی. حداکثر بازه ۹۲ روز.
 * @summary نمای تقویم
 */
export const appointmentsCalendar = (
    params: AppointmentsCalendarParams,
 signal?: AbortSignal
) => {


      return apiClient<CalendarResponse>(
      {url: `/api/v1/appointments/calendar`, method: 'GET',
        params, signal
    },
      );
    }




export const getAppointmentsCalendarQueryKey = (params?: AppointmentsCalendarParams,) => {
    return [
    `/api/v1/appointments/calendar`, ...(params ? [params] : [])
    ] as const;
    }


export const getAppointmentsCalendarQueryOptions = <TData = Awaited<ReturnType<typeof appointmentsCalendar>>, TError = void>(params: AppointmentsCalendarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsCalendar>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppointmentsCalendarQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appointmentsCalendar>>> = ({ signal }) => appointmentsCalendar(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appointmentsCalendar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppointmentsCalendarQueryResult = NonNullable<Awaited<ReturnType<typeof appointmentsCalendar>>>
export type AppointmentsCalendarQueryError = void


export function useAppointmentsCalendar<TData = Awaited<ReturnType<typeof appointmentsCalendar>>, TError = void>(
 params: AppointmentsCalendarParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsCalendar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appointmentsCalendar>>,
          TError,
          Awaited<ReturnType<typeof appointmentsCalendar>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppointmentsCalendar<TData = Awaited<ReturnType<typeof appointmentsCalendar>>, TError = void>(
 params: AppointmentsCalendarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsCalendar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appointmentsCalendar>>,
          TError,
          Awaited<ReturnType<typeof appointmentsCalendar>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppointmentsCalendar<TData = Awaited<ReturnType<typeof appointmentsCalendar>>, TError = void>(
 params: AppointmentsCalendarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsCalendar>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary نمای تقویم
 */

export function useAppointmentsCalendar<TData = Awaited<ReturnType<typeof appointmentsCalendar>>, TError = void>(
 params: AppointmentsCalendarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsCalendar>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppointmentsCalendarQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * زمان‌های آزاد را از شیفت‌ها منهای مرخصی‌ها، نوبت‌های موجود و ظرفیت اتاق‌ها حساب می‌کند و مدت خدمت به‌علاوهٔ فاصلهٔ بین نوبت‌های کلینیک را در نظر می‌گیرد. برای جابه‌جایی نوبت، excludeAppointmentId را بفرستید تا نوبت با خودش تداخل حساب نشود.
 * @summary زمان‌های آزاد
 */
export const appointmentsFreeSlots = (
    params: AppointmentsFreeSlotsParams,
 signal?: AbortSignal
) => {


      return apiClient<FreeSlotResponse[]>(
      {url: `/api/v1/appointments/slots`, method: 'GET',
        params, signal
    },
      );
    }




export const getAppointmentsFreeSlotsQueryKey = (params?: AppointmentsFreeSlotsParams,) => {
    return [
    `/api/v1/appointments/slots`, ...(params ? [params] : [])
    ] as const;
    }


export const getAppointmentsFreeSlotsQueryOptions = <TData = Awaited<ReturnType<typeof appointmentsFreeSlots>>, TError = void>(params: AppointmentsFreeSlotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsFreeSlots>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppointmentsFreeSlotsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appointmentsFreeSlots>>> = ({ signal }) => appointmentsFreeSlots(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appointmentsFreeSlots>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppointmentsFreeSlotsQueryResult = NonNullable<Awaited<ReturnType<typeof appointmentsFreeSlots>>>
export type AppointmentsFreeSlotsQueryError = void


export function useAppointmentsFreeSlots<TData = Awaited<ReturnType<typeof appointmentsFreeSlots>>, TError = void>(
 params: AppointmentsFreeSlotsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsFreeSlots>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appointmentsFreeSlots>>,
          TError,
          Awaited<ReturnType<typeof appointmentsFreeSlots>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppointmentsFreeSlots<TData = Awaited<ReturnType<typeof appointmentsFreeSlots>>, TError = void>(
 params: AppointmentsFreeSlotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsFreeSlots>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appointmentsFreeSlots>>,
          TError,
          Awaited<ReturnType<typeof appointmentsFreeSlots>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppointmentsFreeSlots<TData = Awaited<ReturnType<typeof appointmentsFreeSlots>>, TError = void>(
 params: AppointmentsFreeSlotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsFreeSlots>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary زمان‌های آزاد
 */

export function useAppointmentsFreeSlots<TData = Awaited<ReturnType<typeof appointmentsFreeSlots>>, TError = void>(
 params: AppointmentsFreeSlotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsFreeSlots>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppointmentsFreeSlotsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary یک نوبت
 */
export const appointmentsFindOne = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<AppointmentResponse>(
      {url: `/api/v1/appointments/${id}`, method: 'GET', signal
    },
      );
    }




export const getAppointmentsFindOneQueryKey = (id: string,) => {
    return [
    `/api/v1/appointments/${id}`
    ] as const;
    }


export const getAppointmentsFindOneQueryOptions = <TData = Awaited<ReturnType<typeof appointmentsFindOne>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsFindOne>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppointmentsFindOneQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appointmentsFindOne>>> = ({ signal }) => appointmentsFindOne(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appointmentsFindOne>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppointmentsFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof appointmentsFindOne>>>
export type AppointmentsFindOneQueryError = void


export function useAppointmentsFindOne<TData = Awaited<ReturnType<typeof appointmentsFindOne>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsFindOne>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appointmentsFindOne>>,
          TError,
          Awaited<ReturnType<typeof appointmentsFindOne>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppointmentsFindOne<TData = Awaited<ReturnType<typeof appointmentsFindOne>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsFindOne>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appointmentsFindOne>>,
          TError,
          Awaited<ReturnType<typeof appointmentsFindOne>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppointmentsFindOne<TData = Awaited<ReturnType<typeof appointmentsFindOne>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsFindOne>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary یک نوبت
 */

export function useAppointmentsFindOne<TData = Awaited<ReturnType<typeof appointmentsFindOne>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsFindOne>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppointmentsFindOneQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * ویرایش فیلدهایی که نوبت را جابه‌جا نمی‌کنند. برای تغییر زمان از /reschedule استفاده کنید.
 * @summary ویرایش نوبت
 */
export const appointmentsUpdate = (
    id: string,
    updateAppointmentDto: UpdateAppointmentDto,
 signal?: AbortSignal
) => {


      return apiClient<AppointmentResponse>(
      {url: `/api/v1/appointments/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateAppointmentDto, signal
    },
      );
    }




export const getAppointmentsUpdateMutationKey = () => ['appointmentsUpdate'] as const;

export const getAppointmentsUpdateMutationOptions = <TError = SchedulingErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsUpdate>>, TError,AppointmentsUpdateMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof appointmentsUpdate>>, TError,AppointmentsUpdateMutationVariables, TContext> => {

const mutationKey = getAppointmentsUpdateMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appointmentsUpdate>>, AppointmentsUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  appointmentsUpdate(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppointmentsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof appointmentsUpdate>>>
    export type AppointmentsUpdateMutationBody = UpdateAppointmentDto
    export type AppointmentsUpdateMutationError = SchedulingErrorResponse
    export type AppointmentsUpdateMutationVariables = {id: string;data: UpdateAppointmentDto}

    /**
 * @summary ویرایش نوبت
 */
export const useAppointmentsUpdate = <TError = SchedulingErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsUpdate>>, TError,AppointmentsUpdateMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appointmentsUpdate>>,
        TError,
        AppointmentsUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAppointmentsUpdateMutationOptions(options), queryClient);
    }
    /**
 * حذف نرم — برای ردیفی که اصلاً نباید ثبت می‌شد. لغو کردن نوبتِ واقعی کار درست‌تری است چون سابقه را نگه می‌دارد.
 * @summary حذف نوبت (سطل بازیافت)
 */
export const appointmentsRemove = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/appointments/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getAppointmentsRemoveMutationKey = () => ['appointmentsRemove'] as const;

export const getAppointmentsRemoveMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsRemove>>, TError,AppointmentsRemoveMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof appointmentsRemove>>, TError,AppointmentsRemoveMutationVariables, TContext> => {

const mutationKey = getAppointmentsRemoveMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appointmentsRemove>>, AppointmentsRemoveMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  appointmentsRemove(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppointmentsRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof appointmentsRemove>>>

    export type AppointmentsRemoveMutationError = void
    export type AppointmentsRemoveMutationVariables = {id: string}

    /**
 * @summary حذف نوبت (سطل بازیافت)
 */
export const useAppointmentsRemove = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsRemove>>, TError,AppointmentsRemoveMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appointmentsRemove>>,
        TError,
        AppointmentsRemoveMutationVariables,
        TContext
      > => {
      return useMutation(getAppointmentsRemoveMutationOptions(options), queryClient);
    }
    /**
 * زمان، پزشک یا اتاق نوبت را عوض می‌کند. نفرستادن endAt یعنی مدت نوبت حفظ شود. تداخل با خودِ همین نوبت نادیده گرفته می‌شود.
 * @summary جابه‌جایی نوبت (کشیدن روی تقویم)
 */
export const appointmentsReschedule = (
    id: string,
    rescheduleAppointmentDto: RescheduleAppointmentDto,
 signal?: AbortSignal
) => {


      return apiClient<AppointmentResponse>(
      {url: `/api/v1/appointments/${id}/reschedule`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: rescheduleAppointmentDto, signal
    },
      );
    }




export const getAppointmentsRescheduleMutationKey = () => ['appointmentsReschedule'] as const;

export const getAppointmentsRescheduleMutationOptions = <TError = SchedulingErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsReschedule>>, TError,AppointmentsRescheduleMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof appointmentsReschedule>>, TError,AppointmentsRescheduleMutationVariables, TContext> => {

const mutationKey = getAppointmentsRescheduleMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appointmentsReschedule>>, AppointmentsRescheduleMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  appointmentsReschedule(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppointmentsRescheduleMutationResult = NonNullable<Awaited<ReturnType<typeof appointmentsReschedule>>>
    export type AppointmentsRescheduleMutationBody = RescheduleAppointmentDto
    export type AppointmentsRescheduleMutationError = SchedulingErrorResponse
    export type AppointmentsRescheduleMutationVariables = {id: string;data: RescheduleAppointmentDto}

    /**
 * @summary جابه‌جایی نوبت (کشیدن روی تقویم)
 */
export const useAppointmentsReschedule = <TError = SchedulingErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsReschedule>>, TError,AppointmentsRescheduleMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appointmentsReschedule>>,
        TError,
        AppointmentsRescheduleMutationVariables,
        TContext
      > => {
      return useMutation(getAppointmentsRescheduleMutationOptions(options), queryClient);
    }
    /**
 * حرکت روی گراف وضعیت‌ها: تأیید، مراجعه، در حال انجام، انجام‌شده، عدم مراجعه. لغو از این مسیر پذیرفته نمی‌شود.
 * @summary تغییر وضعیت نوبت
 */
export const appointmentsChangeStatus = (
    id: string,
    changeAppointmentStatusDto: ChangeAppointmentStatusDto,
 signal?: AbortSignal
) => {


      return apiClient<AppointmentResponse>(
      {url: `/api/v1/appointments/${id}/status`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: changeAppointmentStatusDto, signal
    },
      );
    }




export const getAppointmentsChangeStatusMutationKey = () => ['appointmentsChangeStatus'] as const;

export const getAppointmentsChangeStatusMutationOptions = <TError = SchedulingErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsChangeStatus>>, TError,AppointmentsChangeStatusMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof appointmentsChangeStatus>>, TError,AppointmentsChangeStatusMutationVariables, TContext> => {

const mutationKey = getAppointmentsChangeStatusMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appointmentsChangeStatus>>, AppointmentsChangeStatusMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  appointmentsChangeStatus(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppointmentsChangeStatusMutationResult = NonNullable<Awaited<ReturnType<typeof appointmentsChangeStatus>>>
    export type AppointmentsChangeStatusMutationBody = ChangeAppointmentStatusDto
    export type AppointmentsChangeStatusMutationError = SchedulingErrorResponse
    export type AppointmentsChangeStatusMutationVariables = {id: string;data: ChangeAppointmentStatusDto}

    /**
 * @summary تغییر وضعیت نوبت
 */
export const useAppointmentsChangeStatus = <TError = SchedulingErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsChangeStatus>>, TError,AppointmentsChangeStatusMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appointmentsChangeStatus>>,
        TError,
        AppointmentsChangeStatusMutationVariables,
        TContext
      > => {
      return useMutation(getAppointmentsChangeStatusMutationOptions(options), queryClient);
    }
    /**
 * نوبت را لغو می‌کند، دلیل را ثبت می‌کند و زمان آزادشده را به ردیف‌های منطبقِ لیست انتظار اعلام می‌کند.
 * @summary لغو نوبت
 */
export const appointmentsCancel = (
    id: string,
    cancelAppointmentDto: CancelAppointmentDto,
 signal?: AbortSignal
) => {


      return apiClient<AppointmentsCancel200>(
      {url: `/api/v1/appointments/${id}/cancel`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cancelAppointmentDto, signal
    },
      );
    }




export const getAppointmentsCancelMutationKey = () => ['appointmentsCancel'] as const;

export const getAppointmentsCancelMutationOptions = <TError = SchedulingErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsCancel>>, TError,AppointmentsCancelMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof appointmentsCancel>>, TError,AppointmentsCancelMutationVariables, TContext> => {

const mutationKey = getAppointmentsCancelMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appointmentsCancel>>, AppointmentsCancelMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  appointmentsCancel(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppointmentsCancelMutationResult = NonNullable<Awaited<ReturnType<typeof appointmentsCancel>>>
    export type AppointmentsCancelMutationBody = CancelAppointmentDto
    export type AppointmentsCancelMutationError = SchedulingErrorResponse
    export type AppointmentsCancelMutationVariables = {id: string;data: CancelAppointmentDto}

    /**
 * @summary لغو نوبت
 */
export const useAppointmentsCancel = <TError = SchedulingErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsCancel>>, TError,AppointmentsCancelMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appointmentsCancel>>,
        TError,
        AppointmentsCancelMutationVariables,
        TContext
      > => {
      return useMutation(getAppointmentsCancelMutationOptions(options), queryClient);
    }
    /**
 * بیمار نیامد. زمان آزاد می‌شود و رویداد عدم‌مراجعه برای پیگیری CRM منتشر می‌شود.
 * @summary ثبت عدم مراجعه
 */
export const appointmentsMarkNoShow = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<AppointmentResponse>(
      {url: `/api/v1/appointments/${id}/no-show`, method: 'POST', signal
    },
      );
    }




export const getAppointmentsMarkNoShowMutationKey = () => ['appointmentsMarkNoShow'] as const;

export const getAppointmentsMarkNoShowMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsMarkNoShow>>, TError,AppointmentsMarkNoShowMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof appointmentsMarkNoShow>>, TError,AppointmentsMarkNoShowMutationVariables, TContext> => {

const mutationKey = getAppointmentsMarkNoShowMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appointmentsMarkNoShow>>, AppointmentsMarkNoShowMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  appointmentsMarkNoShow(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppointmentsMarkNoShowMutationResult = NonNullable<Awaited<ReturnType<typeof appointmentsMarkNoShow>>>

    export type AppointmentsMarkNoShowMutationError = unknown
    export type AppointmentsMarkNoShowMutationVariables = {id: string}

    /**
 * @summary ثبت عدم مراجعه
 */
export const useAppointmentsMarkNoShow = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsMarkNoShow>>, TError,AppointmentsMarkNoShowMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appointmentsMarkNoShow>>,
        TError,
        AppointmentsMarkNoShowMutationVariables,
        TContext
      > => {
      return useMutation(getAppointmentsMarkNoShowMutationOptions(options), queryClient);
    }
